import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd-mobile'
import enUS from 'antd-mobile/es/locales/en-US'
import { store } from './store'
import { initializeAuth } from './store/slices/authSlice'
import './index.css'
import App from './App.tsx'

// Initialize authentication state on app start
console.log('🚀 App starting... Mock auth enabled:', import.meta.env.VITE_USE_MOCK_AUTH);
store.dispatch(initializeAuth())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ConfigProvider locale={enUS}>
        <App />
      </ConfigProvider>
    </Provider>
  </StrictMode>,
)
